// extracted by mini-css-extract-plugin
export default {"XmlGrid":"Xmls_XmlGrid__NiMpz"};